import { LazyLoader } from "@CodeDaleTheme/lazy-load";

document.addEventListener("DOMContentLoaded", function () {
  // Move the given product id to the front of the recently-viewed list (max 25) and persist it.
  function addProductEntry(productId, recentlyViewedIds) {
    if (recentlyViewedIds === null) recentlyViewedIds = [];
    const productIdString = productId.toString();
    if (!recentlyViewedIds.includes(productIdString)) {
      recentlyViewedIds.unshift(productIdString);
      if (recentlyViewedIds.length > 25) {
        recentlyViewedIds.pop();
      }
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(recentlyViewedIds)
      );
    } else {
      // Already present: remove it, then re-add at the front so it's most recent.
      const existingIndex = recentlyViewedIds.indexOf(productIdString);
      if (existingIndex > -1) {
        recentlyViewedIds.splice(existingIndex, 1);
      }
      recentlyViewedIds.unshift(productIdString);
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(recentlyViewedIds)
      );
    }
  }

  const productJsonEl = document.querySelector("[data-product-json]");
  if (productJsonEl != null) {
    const productId = JSON.parse(productJsonEl.innerHTML);
    const recentlyViewedIds = JSON.parse(
      localStorage.getItem("recently-viewed-products")
    );
    addProductEntry(productId, recentlyViewedIds);
  }
});

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    // Lazy-fetch the recommendations markup once this element scrolls near the viewport.
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((responseHtml) => {
          const wrapper = document.createElement("div");
          wrapper.innerHTML = responseHtml;
          const recommendations = wrapper.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          new LazyLoader(".image-lazy-load");
        })
        .finally(() => {})
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    // Preserve `this` for use inside the scroll listener's function expression.
    const stickyEl = this;
    this.main = document.querySelector(".main-product-section");
    if (!this.main) return;
    const primaryButton = this.main.querySelector(".block-product__buttons");
    const footer = document.querySelector("footer");
    if (!primaryButton) return;
    // Tracks whether the primary (in-page) add-to-cart button is currently on screen.
    var primaryButtonVisible = true;
    window.addEventListener("scroll", function () {
      const buttonRect = primaryButton.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        if (footerRect.top < window.innerHeight - 100) {
          // Footer is in view: hide sticky bar regardless of button position.
          stickyEl.classList.remove("show-sticky-cart");
          document.documentElement.classList.remove("show-sticky-cart-active");
          primaryButtonVisible = true;
        } else {
          if (
            !primaryButtonVisible &&
            buttonRect.top < viewportHeight &&
            buttonRect.bottom > 0
          ) {
            primaryButtonVisible = true;
            stickyEl.classList.remove("show-sticky-cart");
            document.documentElement.classList.remove(
              "show-sticky-cart-active"
            );
          } else if (primaryButtonVisible && buttonRect.bottom <= 0) {
            primaryButtonVisible = false;
            stickyEl.classList.add("show-sticky-cart");
            document.documentElement.classList.add("show-sticky-cart-active");
          }
        }
      } else {
        if (
          !primaryButtonVisible &&
          buttonRect.top < viewportHeight &&
          buttonRect.bottom > 0
        ) {
          primaryButtonVisible = true;
          stickyEl.classList.remove("show-sticky-cart");
          document.documentElement.classList.remove("show-sticky-cart-active");
        } else if (primaryButtonVisible && buttonRect.bottom <= 0) {
          primaryButtonVisible = false;
          stickyEl.classList.add("show-sticky-cart");
          document.documentElement.classList.add("show-sticky-cart-active");
        }
      }
    });
  }
}
customElements.define("sticky-add-cart", StickyAddCart);

// Make the hovered info-gallery card the active one (and clear the others).
const infoGallerySlide = () => {
  const cards = document.querySelectorAll(".info-gallery__card");
  cards.forEach((card) => {
    card.addEventListener("mouseover", (event) => {
      const hoveredCard = event.currentTarget;
      if (!hoveredCard.classList.contains("active")) {
        cards.forEach((otherCard) => {
          otherCard.classList.remove("active");
        });
        hoveredCard.classList.add("active");
      }
    });
  });
};
document.addEventListener("shopify:section:load", function () {
  infoGallerySlide();
});
infoGallerySlide();
